import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const BAKERY = '/images/mockup-local.png';
const MOBILE = '/images/participacion-usuario.png';
const TV = '/images/screen-tv-napoli.png';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6, ease: 'easeOut', delay },
});

export default function ProductShowcase() {
  const { t } = useLanguage();
  const s = t.showcase;

  return (
    <section className="py-14 md:py-20 bg-[#1A222B]" data-testid="showcase-section">
      <div className="section-container">
        <motion.div className="text-center mb-14" {...fadeUp()}>
          <span className="section-badge mb-4 inline-flex">{s.badge}</span>
          <h2 className="heading-lg mb-4">{s.title}</h2>
          <p className="text-[#8A9099] text-base md:text-lg max-w-2xl mx-auto">{s.subtitle}</p>
        </motion.div>

        {/* Main grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          {/* Left: Bakery big image */}
          <motion.div className="lg:col-span-7 relative group overflow-hidden rounded-2xl" {...fadeUp(0.1)}>
            <img src={BAKERY} alt="Mecatos Bakery con MatchPool.live"
              className="w-full h-72 lg:h-[500px] object-cover object-top transition-transform duration-700 group-hover:scale-105"
              data-testid="showcase-bakery-img" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1F2833]/80 via-transparent to-transparent rounded-2xl" />
            <div className="absolute bottom-4 left-4">
              <span className="bg-[#0F6B49]/80 backdrop-blur-sm text-white text-xs font-bold px-3 py-1.5 rounded-full border border-[#0F6B49]">
                {s.lbl3}
              </span>
            </div>
          </motion.div>

          {/* Right: Mobile + TV stacked */}
          <div className="lg:col-span-5 flex flex-col gap-5">
            <motion.div className="relative group overflow-hidden rounded-2xl flex-1" {...fadeUp(0.2)}>
              <img src={MOBILE} alt="App móvil de pronóstico"
                className="w-full h-56 lg:h-[235px] object-cover object-top transition-transform duration-700 group-hover:scale-105"
                data-testid="showcase-mobile-img" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1F2833]/70 via-transparent to-transparent rounded-2xl" />
              <div className="absolute bottom-3 left-3">
                <span className="bg-[#D5A63B]/80 backdrop-blur-sm text-[#1F2833] text-xs font-bold px-3 py-1.5 rounded-full">
                  {s.lbl1}
                </span>
              </div>
            </motion.div>

            <motion.div className="relative group overflow-hidden rounded-2xl flex-1" {...fadeUp(0.3)}>
              <img src={TV} alt="Pantalla TV en vivo"
                className="w-full h-56 lg:h-[235px] object-cover object-center transition-transform duration-700 group-hover:scale-105"
                data-testid="showcase-tv-img" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1F2833]/70 via-transparent to-transparent rounded-2xl" />
              <div className="absolute bottom-3 left-3">
                <span className="bg-[#D5A63B]/80 backdrop-blur-sm text-[#1F2833] text-xs font-bold px-3 py-1.5 rounded-full">
                  {s.lbl2}
                </span>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
